import type { IConsumable } from '@experiences/interfaces';

import type {
    IEnterpriseUpgradeDto,
    IRobotAndServicesLicenses,
} from '../../common/interfaces/licenses';
import type {
    IServiceSelfEnforcementConfiguration,
    ISoftEnforcementConfig,
    ITenantAllocation,
} from '../../common/interfaces/tenant/tenant';
import {
    get,
    post,
    put,
} from '../utility/Requests';

export function generateMLServiceKey(licenseType: string) {
    return post('/api/licensing/generateMLServiceKey', { body: { licenseType } });
}

export function upgradeToTrial(accountUserId: string, accountGlobalId: string, contactInfo: IEnterpriseUpgradeDto, trialSubscriptionCode: string) {
    return put('/api/licensing/trial', {
        body: {
            accountUserId,
            accountGlobalId,
            contactInfo,
            trialSubscriptionCode,
        },
    });
}

export function getTenantProductAllocations({
    accountGlobalId, tenantGlobalId,
}: { url: string; accountGlobalId: string; tenantGlobalId: string }) {
    return get<IRobotAndServicesLicenses>('/api/licensing/tenantProductAllocation', {
        urlParams: {
            accountGlobalId,
            tenantGlobalId,
        },
    });
}

export async function getTenantConsumables({
    accountGlobalId, tenantGlobalId,
}: { url: string; accountGlobalId: string; tenantGlobalId: string }) {
    return await get<IConsumable[]>('/api/licensing/tenantConsumables', {
        urlParams: {
            accountGlobalId,
            tenantGlobalId,
        },
    });
}

export function getTenantAllocations({
    url: _url, accountGlobalId,
}: { url: string; accountGlobalId: string }) {
    return get<ITenantAllocation[]>('/api/licensing/tenantAllocations', { urlParams: { accountGlobalId } });
}

export function getEnforcementConfigForServices({
    tenantId, unit, services,
}: { tenantId: string; unit: string; services?: string[] }) {
    return put<ISoftEnforcementConfig>('/api/licensing/soft-enforcement-configuration/query/services', {
        body: {
            tenantId,
            unit,
            ...(services ? { services } : {}),
        },
    });
}
export function updateSoftEnforcementSettings({
    tenantId, unit, services,
}: { tenantId: string; unit: string; services: IServiceSelfEnforcementConfiguration[] }) {
    return put('/api/licensing/soft-enforcement-configuration', {
        body: {
            tenantId,
            unit,
            services,
        },
    });
}

